import React from 'react';
import { Link } from 'react-router-dom';
import { Box } from '@material-ui/core';
import Routes from 'routes';
import { useAppContext } from 'contexts/AppContext';
import { alert } from 'globals/colors';
import defaultLocales from 'globals/locales/default';
import { useBillingType } from 'globals/hooks/useBillingType';
import { UserBillingType } from 'globals/types';
import FsAlertIcon from 'ui-elements/icons/FsAlert';
import {
  Button,
  ContentBox,
  Info,
  WrapperBox,
} from './TopBarNotification.style-elements';

const TopBarNotification: React.FC = ({ children }) => {
  const { isUpgraded } = useAppContext();
  const isUserBillingTypeExcluded = useBillingType(UserBillingType.EXCLUDED);
  const showButton = isUpgraded && !isUserBillingTypeExcluded;
  const { buttonLabel } = defaultLocales.topBarSection;
  return (
    <WrapperBox>
      <ContentBox mt={1} mb={1}>
        <Box mr={2}>
          <FsAlertIcon color={alert.ERROR} />
        </Box>
        <Box mr={2}>
          <Info>{children}</Info>
        </Box>
      </ContentBox>
      {showButton && (
        <Box mt={1} mb={1}>
          <Button component={Link} to={Routes.BILLINGS}>
            {buttonLabel}
          </Button>
        </Box>
      )}
    </WrapperBox>
  );
};

export default TopBarNotification;
